import { AutogenLayoutOfficeFUTAReport } from './autogen/AutogenLayoutOfficeFUTAReport';


export class OfficeFUTAReport extends AutogenLayoutOfficeFUTAReport {

    checkboxIncludeSettlementOnChange() {
        this.excludabletextboxPayee.textbox.clear();
        if(this.checkboxIncludeSettlement.checked) {
            this.excludabletextboxPayee.textbox.lookupModel = "lme/settlement/transfer-to-settlement-payee";
            this.excludabletextboxPayee.textbox.lookupModelLayout = "lme/settlement/TransferToSettlementPayeeLookup";
        }
        else {
            this.excludabletextboxPayee.textbox.lookupModel = "lme/settlement/officepayroll/off-payee";
            this.excludabletextboxPayee.textbox.lookupModelLayout = "lme/settlement/officepayroll/OfficePayeeLookup";
        }
    }
}


